import PropTypes from 'prop-types';
import { OptionsPropType } from '../../shared/propTypes/common';


export const ObligationPropTypes = PropTypes.shape({
  NOL: PropTypes.oneOf(['RECORD', 'UTILIZE']),
  chartName: PropTypes.string,
  chartNameSource: PropTypes.string,
  comment: PropTypes.string,
  companyCode: PropTypes.string.isRequired,
  connectionName: PropTypes.string,
  connectionNameSource: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  countryTaxType: PropTypes.string.isRequired,
  countryTaxTypeDescription: PropTypes.string.isRequired,
  currentTaxRate: PropTypes.number.isRequired,
  currentTaxRateSource: PropTypes.number.isRequired,
  deferredTaxRate: PropTypes.number.isRequired,
  deferredTaxRateSource: PropTypes.number.isRequired,
  enabledFlag: PropTypes.oneOf(['Y', 'N']).isRequired,
  federalFTCLimit: PropTypes.string,
  functionalCurrency: PropTypes.string.isRequired,
  functionalCurrencySource: PropTypes.string.isRequired,
  homeOfficeCompanyCode: PropTypes.string,
  legalEntity: PropTypes.string.isRequired,
  localTaxType: PropTypes.string,
  localTaxTypeSource: PropTypes.string,
  periodName: PropTypes.string.isRequired,
  recordFTC: PropTypes.oneOf(['Y', 'N']),
  recordFTCSource: PropTypes.string,
  recordVA: PropTypes.oneOf(['ALL', 'NOL']),
  secondaryTax: PropTypes.oneOf(['Branch', 'Shareholder']),
  secondaryTaxSource: PropTypes.string,
  statCurrency: PropTypes.string,
  statCurrencySource: PropTypes.string,
  stateApportionmentRate: PropTypes.number,
  stateMinimumTax: PropTypes.number,
  statePrePostNOL: PropTypes.oneOf(['PRE', 'POST']),
  taxCurrency: PropTypes.string.isRequired,
  taxCurrencySource: PropTypes.string.isRequired,
  usTaxType: PropTypes.string,
  usTaxTypeSource: PropTypes.string,
  filingGroup: PropTypes.string,
});

export const UploadedObligationsPropTypes = PropTypes.shape({
  chartName: PropTypes.string,
  comment: PropTypes.string,
  companyCode: PropTypes.string,
  connectionName: PropTypes.string,
  countryCode: PropTypes.string,
  countryTaxType: PropTypes.string,
  countryTaxTypeDescription: PropTypes.string,
  deferredTaxRate: PropTypes.number,
  enabledFlag: PropTypes.string,
  federalFTCLimit: PropTypes.string,
  functionalCurrency: PropTypes.string,
  legalEntity: PropTypes.string,
  localTaxType: PropTypes.string,
  NOL: PropTypes.string,
  periodName: PropTypes.string,
  recordFTC: PropTypes.string,
  recordVA: PropTypes.string,
  secondaryTax: PropTypes.string,
  stateApportionmentRate: PropTypes.number,
  stateMinimumTax: PropTypes.number,
  statePrePostNOL: PropTypes.string,
  taxCurrency: PropTypes.string,
  currentTaxRate: PropTypes.number,
  usTaxType: PropTypes.string,
  statCurrency: PropTypes.string,
  filingGroup: PropTypes.string,
});

export const LookUpDataPropTypes = PropTypes.shape({
  chartNameOptions: OptionsPropType,
  usTaxTypeOptions: OptionsPropType,
  localTaxTypeOptions: OptionsPropType,
  currencyCodeOptions: OptionsPropType,
  connectionOptions: OptionsPropType,
  NOLOptions: OptionsPropType,
  RecordVAOptions: OptionsPropType,
  companyCodes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    subledgerFlag: PropTypes.bool.isRequired,
    connName: PropTypes.string,
  })),
  countryTaxTypes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    countryCode: PropTypes.string,
    taxRate: PropTypes.number.isRequired,
    defTaxRate: PropTypes.number.isRequired,
  })),
  companyCodeBasedInitialData: PropTypes.objectOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    connection: PropTypes.string,
    chartName: PropTypes.string,
    functionalCurrency: PropTypes.string.isRequired,
    statCurrency: PropTypes.string,
    recordFTC: PropTypes.string,
  })),
  obligationBasedInitialData: PropTypes.objectOf(ObligationPropTypes),
});
